'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTracker } from '@lichtblick/tracker';
import { Text, TextCTA } from '@lichtblick/ui-components';
import { useCallback } from 'react';
import { buildUrl } from '../../helpers';
import { assertExhaustive } from '../../helpers/assertExhaustive';
import { AImage } from '../AImage/AImage';
import { AVideo } from '../AVideo/AVideo';
import { MAnimatedIllustration } from '../MAnimatedIllustration/MAnimatedIllustration';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { ColumnItemContainer, StyledHeadline } from './MColumnItem.styles';
const MediaContent = ({ content: contentList })=>{
    if (!contentList?.[0]) {
        return null;
    }
    const content = contentList[0];
    switch(content.component){
        case 'a-image':
            return /*#__PURE__*/ _jsx(AImage, {
                ...content
            });
        case 'a-video':
            return /*#__PURE__*/ _jsx(AVideo, {
                ...content
            });
        case 'm-animated-illustration':
            return /*#__PURE__*/ _jsx(MAnimatedIllustration, {
                ...content
            });
        case 'svg-icon':
            return /*#__PURE__*/ _jsx(SvgIcon, {
                ...content
            });
        default:
            assertExhaustive(content);
    }
};
export const MColumnItem = ({ columnAlignment, columnWidth, headline, link, linkLabel, media, text, textFirst = false })=>{
    const { trackCustomEvent } = useTracker();
    const linkClickHandler = useCallback(()=>{
        trackCustomEvent({
            customProps: {
                navigation_area: 'Body',
                navigation_element: linkLabel
            },
            eventName: 'navigation'
        });
    }, [
        linkLabel,
        trackCustomEvent
    ]);
    const href = link && buildUrl(link);
    return /*#__PURE__*/ _jsxs(ColumnItemContainer, {
        $alignment: columnAlignment ?? '',
        $width: columnWidth ?? '',
        "data-testid": "column-item",
        children: [
            !textFirst && /*#__PURE__*/ _jsx(MediaContent, {
                content: media
            }),
            headline && /*#__PURE__*/ _jsx(StyledHeadline, {
                renderAs: "h3",
                size: "S",
                children: headline
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                children: text
            }),
            Boolean(textFirst) && /*#__PURE__*/ _jsx(MediaContent, {
                content: media
            }),
            typeof href === 'string' && typeof linkLabel === 'string' && /*#__PURE__*/ _jsx(TextCTA, {
                as: "a",
                href: href,
                onClick: linkClickHandler,
                children: linkLabel
            })
        ]
    });
};

//# sourceMappingURL=MColumnItem.js.map